import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../states/state.model';


let authFS= createFeatureSelector<State>('auth');
export let authState= createSelector(authFS,(state:any)=> state.login)
export let userConnected= createSelector(authFS,(state:any)=> state.user)